import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Textarea,
} from '@heroui/react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { $fetch } from 'utils/fetch'

export default function EditKnowledgeBase({ onSuccess, knowledgeBase, open, setOpen }) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formData, setFormData] = useState({
    name: knowledgeBase.name,
    description: knowledgeBase.description,
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    try {
      await $fetch(`/v1/knowledge/${knowledgeBase.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
      setOpen(false)
      onSuccess()
    }
    catch (error) {
      console.error('Failed to update knowledge base:', error)
      toast.error('Failed to update knowledge base')
    }
    finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      isOpen={open}
      onOpenChange={setOpen}
      size="2xl"
      classNames={{
        base: 'border-2 border-gray-200 shadow-none rounded-none',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <div>
            <h3 className="text-lg font-semibold">Edit Knowledge Base</h3>
            <p className="mt-1 text-sm text-gray-600">
              Update the name and description of your knowledge base.
            </p>
          </div>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit} className="w-full space-y-4">
            <div>
              <label className="mb-2 block text-sm font-medium">Name</label>
              <Input
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                radius="none"
                className="border-gray-200"
              />
            </div>

            <div>
              <label className="mb-2 block text-sm font-medium">Description</label>
              <Textarea
                value={formData.description}
                onChange={e => setFormData({ ...formData, description: e.target.value })}
                radius="none"
                className="border-gray-200"
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="bordered"
            onPress={() => setOpen(false)}
            radius="none"
            className="border-gray-200"
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onPress={handleSubmit}
            isLoading={isSubmitting}
            radius="none"
          >
            {isSubmitting ? 'Saving...' : 'Save changes'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
